import React from "react";
import { useTranslation, Trans } from "next-i18next";
import parse from "html-react-parser";
import CardWithIcon from "../../components/v2/cards/card-with-icon";
import {
    DiscoveryAutomated, Docker, K8s, Linux,
    OneViewTotalControl, RapidTroubleshooting, Windows
} from "../../components/v2/icons";
import Testimonial from "../../components/v2/mw-carousel/testimonial";
import AgentIntegration from "../../components/v2/agent-integration";
import Accordion from "../../components/v2/accordion/accordion";
import ProductResources from "../../components/v2/product/product-resource";
import ProductHeroSection from "../../components/v2/common/product-hero";
import ProductTour from "../../components/v2/product/product-tour";
import FeaturesMonitoring from "../../components/v2/tabs/features-monitoring";
import '../../styles/scss/_faq-section.module.scss';

export default function ContainerMonitoring() {
    const { t } = useTranslation("common");

    const featuresData = t('product.container-monitoring.features.detailedFeatures', { returnObjects: true }) as any[]
    const features = Array.isArray(featuresData) ? featuresData : []

    const faqsData = t('product.container-monitoring.faq.questions', { returnObjects: true }) as any[]
    const faqs = Array.isArray(faqsData) ? faqsData : []

    const resourceData = t('product.container-monitoring.resources', { returnObjects: true }) as any[]
    const resource = Array.isArray(resourceData) ? resourceData : []

    const cardWithIconData = t('product.container-monitoring.cardWithIcon', { returnObjects: true }) as any[]

    const productTourData = t('product.container-monitoring.productTour', { returnObjects: true }) as any

    const agentIntegrationData = t('product.container-monitoring.agentIntegration', { returnObjects: true }) as any

    const agentDeployData = t('product.shared.agentDeploy', { returnObjects: true }) as any[]
    const agentDeployArray = Array.isArray(agentDeployData) ? agentDeployData : []

    const agentDeploy = agentDeployArray.map(agent => ({
        ...agent,
        icon: agent.key === 'kubernetes' ? <K8s/> :
              agent.key === 'linux' ? <Linux/> :
              agent.key === 'docker' ? <Docker/> :
              agent.key === 'windows' ? <Windows/> :
              <span className={"text-gradient"}>450+</span>
    }))

    return (
        <>
            <ProductHeroSection title={<h1>{t('product.container-monitoring.hero.title')} <span>{t('product.container-monitoring.hero.titleHighlight')}</span></h1>}
                                description={t('product.container-monitoring.hero.description')}
                                img={"/images/product/container-monitoring.png"} imgMobile={"/images/product/container-monitoring-mobile.webp"} imgAlt={t('product.container-monitoring.hero.imageAlt')} preloadImg
                                hasActions={true} tips={t('product.hero.tips')}/>

            <section className={'mw-card-with-icon product-page'}>
                <div className={'container'}>
                    <h2>{t('product.container-monitoring.section.title')}</h2>
                    <p>{t('product.container-monitoring.section.description')}</p>
                    <div className={'card-items'}>
                        <div className={'d-flex card-items'}>
                            <CardWithIcon icon={<DiscoveryAutomated/>} title={cardWithIconData[0].title}
                                          description={cardWithIconData[0].description}/>
                            <CardWithIcon icon={<OneViewTotalControl/>} title={cardWithIconData[1].title}
                                          description={cardWithIconData[1].description}/>
                            <CardWithIcon icon={<RapidTroubleshooting/>} title={cardWithIconData[2].title}
                                          description={cardWithIconData[2].description}/>

                        </div>
                    </div>
                </div>
            </section>

            <FeaturesMonitoring productFeatures={features}
                                title={<h2>{t('product.container-monitoring.features.title')}</h2>} tourId={"container-tour"}/>

            <Testimonial/>

            <ProductTour tourSrc={"https://app.supademo.com/embed/clzjqs2yk21s79x77ouw4cqx9?embed_v=2"}
                         title={productTourData.title} tourId={"container-tour"} description={productTourData.description}/>

            <AgentIntegration
                agentDeploy={agentDeploy}
                title={
                    <h2>
                        <Trans
                            i18nKey="product.container-monitoring.agentIntegration.title"
                            components={{ highlight: <span className="text-gradient" /> }}
                        />
                    </h2>
                }
                description={agentIntegrationData.description}
            />

            <ProductResources resources={resource} title={t('product.shared.resources.title')}/>

            <section className={"faq-section"}>
                <div className={"container"}>
                    <h2>{t('product.container-monitoring.faq.title')}</h2>
                    <p>{t('product.container-monitoring.faq.subtitle')}</p>
                    <div className={"faq-item"}>
                        <Accordion faqs={faqs.map(faq => ({
                            ...faq,
                            answerPlain: faq.text,
                            text:
                                faq.textHtml != null && faq.textHtml !== ""
                                    ? parse(faq.textHtml)
                                    : <p>{faq.text}</p>
                        }))} showGroups={true}/>
                    </div>
                </div>
            </section>

        </>
    )
}